export default {
  'connectionGroupConfig.title': 'Manage Connection Groups',
};
